export const AUDIO_TRANSCRIPTION_STATUS = {
  UPLOADING: 'UPLOADING',
  TRANSCRIBING: 'TRANSCRIBING',
  REVIEW: 'REVIEW',
  TRAINING: 'TRAINING',
  TRAINED: 'TRAINED',
  FAILED: 'FAILED',
} as const;

export type AudioTranscriptionStatus =
  (typeof AUDIO_TRANSCRIPTION_STATUS)[keyof typeof AUDIO_TRANSCRIPTION_STATUS];

export interface IAudioTranscription {
  id: string;
  uploadId: string;
  upload?: {
    id: string;
    fileKey: string;
    originalFileKey: string;
    mimeType: string;
    size: number;
    cdnUrl?: string;
  };
  chatbotId: string;
  userId: string;

  title?: string;
  description?: string;
  speaker?: string;
  recordingDate?: string;
  languageCode: string;

  transcribeJobName?: string;
  transcribeJobStatus?: string;

  rawTranscript?: string;
  editedTranscript?: string;
  confidence?: number;

  engineUsed?: string;
  durationSeconds?: number;

  vectorIds: string[];
  vectorCount?: number;
  charCount?: number;

  status: AudioTranscriptionStatus;
  errorMessage?: string;

  uploadCompletedAt?: string;
  transcriptionStartedAt?: string;
  transcriptionCompletedAt?: string;
  trainingCompletedAt?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface IPresignedUrlResponse {
  presignedUrl: string;
  s3Key: string;
  uploadId: string;
  audioTranscriptionId: string;
}

export interface ISupportedLanguage {
  code: string;
  name: string;
}

export interface IAudioAnalytics {
  totalFiles: number;
  totalDurationMinutes: number;
  totalCharCount: number;
  audioMinutes: {
    used: number;
    limit: number;
    percentage: number;
    isUnlimited: boolean;
  };
  statusCounts: {
    trained: number;
    training: number;
    transcribing: number;
    review: number;
    failed: number;
    uploading: number;
  };
  planLimits: {
    maxFileSizeMB: number;
    maxFilesPerBot: number;
    maxDurationMinutes: number;
    monthlyMinutes: number;
    isUnlimited: boolean;
  };
  chatbot: {
    id: string;
    name: string;
  };
}
